<template>
  <div class="mod-user-comment">
    <div class="boss-list">
      <div class="boss-item">
        <img class="boss-item__avatar" src="//s1.huishoubao.com/static/pc/1001/img/person1.png">
        <div class="boss-item__right">
          <h3 class="boss-item__name">黄承松</h3>
          <p class="boss-item__title">卷皮网 CEO，平价零售模式开创者</p>
          <p class="boss-item__text">我们平时喜欢买买买，很多有价值的数码产品都闲置了。回收宝既避免了个人交易浪费时间，又有专业的流程保障信息安全，2年我卖了4部手机，与其让它在角落积灰，不如交给回收宝变钱！</p>
        </div>
      </div>
      <div class="boss-item">
        <img class="boss-item__avatar" src="//s1.huishoubao.com/static/pc/1001/img/person2.png">
        <div class="boss-item__right">
          <h3 class="boss-item__name">奉佑生</h3>
          <p class="boss-item__title">映客App CEO，最大的娱乐直播平台</p>
          <p class="boss-item__text">映客团队有很多主播，他们的手机很多，换的很快，我就给大家推荐了回收宝，团队的体验反馈非常好。交易方便、安全正规、价格高；在线自助估价，顺丰免费上门收件，很快就能拿到钱，试试看！</p>
        </div>
      </div>
    </div>
    <ul class="comment-list">
      <li class="comment-item" v-for="(item, index) in commentList" :key="index">
        <img class="comment-item__avatar" :src="'https://www.huishoubao.com/static/pc/1001/img/avator/comment_'+item.img+'.jpg.jpg'">
        <div class="comment-item__right">
          <h3 class="comment-item__mobile" v-text="item.tel"></h3>
          <p class="comment-item__date" v-text="item.date"></p>
          <p class="comment-item__text" v-text="item.comment"></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getCommentList } from '@/apis/zx';
export default {
  data () {
    return {
      commentList: []
    };
  },
  async mounted () {
    let res = await getCommentList();
    if (!res.success || !res._data.list.length) {
      return;
    }
    this.commentList = res._data.list;
  }
};
</script>

<style lang="postcss" scoped>
.comment {
  &-list {
    padding: 0px 40px 0;
  }
  &-item {
    overflow: hidden;
    padding-top: 20px;
    &__avatar {
      float: left;
      width: 70px;
      height: 70px;
      margin-left: 8px;
      border-radius: 50%;
    }
    &__right {
      font-size: 14px;
      padding-bottom: 20px;
      margin-left: 100px;
      border-bottom: 1px solid #eee;
    }
    &__mobile {
      font-size: 14px;
      margin-top: 10px;
      font-weight: 400;
      color: #babcc2;
    }
    &__date {
      font-size: 12px;
      margin-top: 10px;
      color: #babcc2;
    }
    &__text {
      margin-top: 10px;
      color: #656b6e;
    }
  }
}

.boss {
  &-list {
    overflow: hidden;
  }
  &-item {
    float: left;
    width: 50%;
    padding-top: 30px;
    font-size: 16px;
    color: #656b6f;
    &__avatar {
      float: left;
      margin-top: 7px;
      margin-left: 55px;
    }
    &__right {
      padding: 0 60px 0 240px;
    }
    &__name {
      font-size: 24px;
      color: #3b3d40;
    }
    &__title {
      font-size: 14px;
      margin-top: 8px;
      padding-bottom: 20px;
      border-bottom: 1px solid #dedede;
    }
    &__text {
      font-size: 14px;
      line-height: 24px;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/evInfo/mod-user-comment.vue